<template>
  <editor-content class="editor editor2" data-placeholder="コメントを入力する" :editor="editor" @keydown.native="keydownHandler" />
</template>

<script>
import { Editor, EditorContent, VueRenderer } from '@tiptap/vue-2'
import { mapState } from 'vuex'
import Text from '@tiptap/extension-text'
import Document from '@tiptap/extension-document'
import Paragraph from '@tiptap/extension-paragraph'
import Placeholder from '@tiptap/extension-placeholder'
import HardBreak from '@tiptap/extension-hard-break'
import tippy from 'tippy.js'
import Mention from '@tiptap/extension-mention'
import BasicMentionList from '@/components/particles/extensions/BasicMentionList'
import computedValue from '@/mixins/computedValue'
import {REGEX_JAPANESE} from "~/contants/base";

export default {
  name: 'CommentInput',
  components: {
    EditorContent,
  },
  props: ['value'],
  mixins: [computedValue],
  data: () => ({
    editor: null,
  }),
  mounted() {
    this.editor = new Editor({
      content: this.computedValue,
      extensions: [
        Document,
        Paragraph,
        Text,
        HardBreak,
        Placeholder.configure({
          placeholder: 'コメントを入力',
        }),
        Mention.configure({
          HTMLAttributes: {
            class: 'mention',
          },
          suggestion: {
            items: ({query}) => {
              const users = this.users
                .map((user) => ({
                  value: user.id,
                  label: user.full_name,
                }))
                .filter((user) => {
                  return user.label.toLowerCase().includes(query?.trim().toLowerCase())
                })

              return users
            },
            command: ({ editor, range, props }) => {
              editor
                .chain()
                .focus()
                .insertContentAt(range, [
                  {
                    type: 'mention',
                    attrs: {
                      id: props.value,
                      label: props.label,
                    },
                  },
                ])
                .run()
            },
            render: () => {
              let component
              let popup

              return {
                onStart: (props) => {
                  component = new VueRenderer(BasicMentionList, {
                    parent: this,
                    propsData: props,
                  })

                  popup = tippy('body', {
                    getReferenceClientRect: props.clientRect,
                    appendTo: () => document.body,
                    content: component.element,
                    showOnCreate: true,
                    interactive: true,
                    trigger: 'manual',
                    placement: 'bottom-start',
                  })

                  if (popup.length) {
                    popup[0].popper.classList.add('mention-popup')
                  }
                },
                onUpdate(props) {
                  component.updateProps(props)

                  popup[0].setProps({
                    getReferenceClientRect: props.clientRect,
                  })
                },
                onKeyDown(props) {
                  if (props.event.key === 'Escape') {
                    popup[0].hide()

                    return true
                  }

                  return component.ref?.onKeyDown(props)
                },
                onExit() {
                  popup[0].destroy()
                  component.destroy()
                },
              }
            },
          },
        }),
      ],
      onUpdate: () => {
        this.computedValue = this.editor.getJSON()
      },
    })
  },
  computed: {
    ...mapState({
      users: state => state.frontend.user.users,
    }),
  },
  methods: {
    async keydownHandler(event) {
      if (event.key === 'Enter' && !event.shiftKey) {
        if (!this.computedValue) {
          return
        }
        event.preventDefault()
        event.stopPropagation()
        const isMac = navigator.userAgent.indexOf("Mac") !== -1
        const textContent = this.editor.state.doc.textContent
        if (isMac) {
          const textSelected = document.getSelection().toString()
          if (textSelected && textContent.includes(textSelected)) {
            return
          }
        }
        
        this.$emit('submit')
        if (isMac && REGEX_JAPANESE.test(textContent)) {
          setTimeout(() => {
            this.editor.chain().clearContent().run()
          }, 5)
          return
        }
        this.editor.chain().clearContent().run()
      }
    },
  },
}
</script>
